// extracted by mini-css-extract-plugin
var _1 = "FlatTableLayout-modulepageActions__EOH9o PageActions-modulePageActions__lL8Sl";
export { _1 as "pageActions" }
